import React from "react";
import { 
  Building2, 
  MapPin, 
  Globe, 
  ShieldCheck, 
  Users2, 
  Search,
  Zap
} from "lucide-react";

const AdminProfileDocs = () => {
  return (
    <div className="space-y-12 pb-20">
      {/* Header */}
      <section>
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-purple-50 border border-purple-100 mb-4">
          <Building2 size={14} className="text-purple-600" />
          <span className="text-[10px] font-black text-purple-600 uppercase tracking-widest">Setup Guide</span>
        </div>
        <h1 className="text-4xl font-black text-gray-900 tracking-tight mb-4">Program Identity</h1>
        <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
          Learn how to configure your organization's profile to ensure maximum visibility in the 
          Nuvio Sport Marketplace.
        </p>
      </section>

      {/* Step 1: Physical Presence */}
      <section className="bg-white border border-gray-100 rounded-[2.5rem] p-8 shadow-sm">
        <div className="flex flex-col md:flex-row gap-8">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-red-100 p-2 rounded-xl text-red-600">
                <MapPin size={24} />
              </div>
              <h3 className="text-xl font-bold text-gray-900">The Discovery Rule</h3>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Nuvio uses a <strong>Radius-Based Discovery Engine</strong>. If your program does not have a 
              verified physical address, it will not appear when athletes search for "Programs near me."
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-xs font-bold text-gray-700">
                <ShieldCheck size={16} className="text-green-500" /> 
                Enter Street, City, and Zip
              </div>
              <div className="flex items-center gap-2 text-xs font-bold text-gray-700">
                <ShieldCheck size={16} className="text-green-500" /> 
                Click "Fetch" to verify GPS coordinates
              </div>
            </div>
          </div>
          <div className="w-full md:w-72 bg-gray-50 rounded-2xl p-6 border border-dashed border-gray-200">
             <div className="flex items-center gap-2 mb-4">
                <Search size={14} className="text-gray-400" />
                <div className="h-2 w-24 bg-gray-200 rounded-full"></div>
             </div>
             <div className="space-y-2">
                <div className="h-10 bg-white border border-gray-200 rounded-lg flex items-center px-3 gap-2">
                    <div className="w-4 h-4 rounded-full bg-purple-500"></div>
                    <div className="h-2 w-16 bg-gray-100 rounded-full"></div>
                </div>
                <p className="text-[9px] text-gray-400 text-center italic mt-2 uppercase tracking-widest">Live Marketplace View</p>
             </div>
          </div>
        </div>
      </section>

      {/* Step 2: Branding */}
      <section className="grid md:grid-cols-2 gap-8">
        <div className="p-8 bg-slate-900 rounded-[2rem] text-white">
          <Globe className="text-blue-400 mb-4" size={32} />
          <h4 className="text-lg font-bold mb-2">Digital Footprint</h4>
          <p className="text-slate-400 text-sm leading-relaxed">
            Link your Website and Instagram handle. This creates a "One-Click Connect" for athletes 
            who want to see your team's highlight reels and culture.
          </p>
        </div>
        <div className="p-8 bg-purple-600 rounded-[2rem] text-white">
          <Users2 className="text-purple-200 mb-4" size={32} />
          <h4 className="text-lg font-bold mb-2">Demographic Targets</h4>
          <p className="text-purple-100 text-sm leading-relaxed">
            Specify your Age Groups and Gender offerings. This ensures the Nuvio AI only 
            suggests your program to athletes who meet your roster requirements.
          </p>
        </div>
      </section>

      {/* Footer Insight */}
      <section className="text-center pt-8 border-t border-gray-100">
        <div className="inline-flex items-center gap-2 text-amber-600 bg-amber-50 px-4 py-2 rounded-full border border-amber-100 mb-4">
          <Zap size={14} fill="currentColor" />
          <span className="text-[10px] font-black uppercase tracking-widest">Admin Tip</span>
        </div>
        <p className="text-xs text-gray-500 max-w-lg mx-auto italic">
            "Your Administrator ID is your key. Only you can authorize Coaches to view 
            your organization's private talent data."
        </p>
      </section>
    </div>
  );
};

export default AdminProfileDocs;